import { styled } from '@mui/material/styles'

export const StyledBadgeSmall = styled('div')`
  position: absolute;
  top: 15px;
  right: 16px;
  width: 8px;
  height: 8px;
  background: ${props => props.background || '#FF0000'};
  border-radius: 50%;
`